import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import checkStatus from './jsFunctions/checkStatus.js'
import { useFormik } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import parentFormSchema, { getParentContactErrors } from './components/ParentInformation/parentFormSchema.js';
import {
    flattenParentStudents,
    getChildCampusName,
    getStudentFullName,
    getStudentGivenName,
    getParentEmails,
    getPrimaryCampusName,
    toReenrolmentChildren,
    toReenrolmentMedicalRecords,
    enrichEnrolledChildrenWithCampus,
    buildEnrolledChildrenFromForm,
    buildCampusCredits,
    buildCampusOutstanding,
    isEligibleForReenrolment,
} from './utils/parentHistoryHelpers.js';
import { storeCampusSessions } from './utils/campusPaymentCharges.js';
import { reenrolmentYear } from './utils/years';
import { hasOutstandingCampusPayment, shouldRedirectToCompletion } from './utils/campusPaymentStatus.js';
import { paidCampusForChild, paymentContextOnServer, resolveCampusPaymentResume } from './utils/paymentResume.js';
import { startBackgroundUpload, pendingBackgroundUpload, uploadKey } from './utils/backgroundUpload.js';
import { fetchFamilyMedicareFiles, fetchStudentMedicareFiles } from './api/cardImages';
import { cardSideMissing, emptyCardSlots, readyToUpload, slotsFromStoredFiles } from './utils/storedCardImages';
import {
    getStudentMedicalErrors,
    getFamilyMedicareErrors,
    parseMonthYear,
    isValidMonthYear,
    isMonthYearInFuture,
    splitMedicareNumber,
    getMedicareBase,
} from './utils/studentMedicalValidation.js';
import useParentHistory from './hooks/useParentHistory';
import { familyMedicareFromRecords } from './utils/familyMedicare';
import { setParentHistory } from './features/parentInfo/parentInfoSlice';
import {
    getParentRecordStatusPayload,
    hasParentContactChanged,
    snapshotParentContactRecord,
} from './utils/parentRecordStatus';
import { formValuesFromSavedContact, mergeSavedStudentMedical } from './utils/savedParentContact';
import { buildPersonalandMedPayload } from './utils/personalAndMedPayload';

import Heading from './components/Heading/Heading';
import Heading6 from './components/Heading6/Heading6';
import Paragraph from './components/Paragraph/Paragraph';
import MainTemplate from './components/MainTemplate/MainTemplate';
import StudentMedicalForm from './components/StudentMedicalForm/StudentMedicalForm';

import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import StayPrimaryPortraitOutlinedIcon from '@mui/icons-material/StayPrimaryPortraitOutlined';
import HomeIcon from '@mui/icons-material/Home';
import SignpostIcon from '@mui/icons-material/Signpost';
import LocationCityIcon from '@mui/icons-material/LocationCity';

import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import ButtonWithIcon from './components/ButtonWithIcon/ButtonWithIcon';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import InputLabel from '@mui/material/InputLabel';
import classes from './ParentInformation.module.css'

import URL2 from './config.js'
import Message from './components/Message/Message.js';
import CircularProgress from '@mui/material/CircularProgress';
import LoadingBackdrop from './components/LoadingBackdrop/LoadingBackdrop.js';
import StepBackButton from './components/StepBackButton/StepBackButton';
import CustomSnackbar from './components/common/snackbar/CustomSnackbar.jsx';
import ModeEditOutlineTwoToneIcon from '@mui/icons-material/ModeEditOutlineTwoTone';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Alert, FormControlLabel, Checkbox, useTheme, useMediaQuery, Button, Typography, Chip, Avatar, IconButton, LinearProgress } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { green } from '@mui/material/colors';
import Medicare from './components/ParentInformation/Medicare.jsx';
import ParentDetails from './components/ParentDetails/ParentDetails.js';
import IOSSegmentedControl from './components/common/IOSSegmentedControl';

/** Parent-history students use student_code / student_name + student_surname. */
const childCode = (child) => child?.student_code || child?.stud_code || '';
const studentCardKey = (parentId, studentCode, files) =>
    uploadKey(`student:${parentId}:${studentCode}`, files);
const childGivenName = (child) => getStudentGivenName(child);
const childFullName = (child) => getStudentFullName(child);
const childYearLevel = (child) => {
    const year = child?.year ?? child?.year_grp;
    return year === null || year === undefined || year === '' ? 'Enrolled' : String(year);
};

const isAdelaideCampusFamily = (college, children) => {
    const campusNames = [...new Set((children || []).map(getChildCampusName).filter(Boolean))];
    if (campusNames.length > 0) {
        return campusNames.every((name) => name === 'Adelaide');
    }
    return college === 'Adelaide';
};

const Updatedetails = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    let ParentID;
    let credit_amount;
    let isGhostLogin;

    const [SessionID, setSessionID] = useState();
    const [college, setCollege] = useState();
    const [famName, setfamName] = useState();
    const [par_email, setpar_email] = useState();
    const [childrens, setchildrens] = useState([]);
    const [enrolledchildrens, setenrolledchildrens] = useState([]);
    const [isEditingPersonal, setIsEditingPersonal] = useState(false);
    const [isEditingAddress, setIsEditingAddress] = useState(false);
    const [attemptedStep0Next, setAttemptedStep0Next] = useState(false);
    const [activeSubStep, setActiveSubStep] = useState(0); // 0 = Parent Details & Enrolment Selection, 1..N = Student Medical Screen

    const [updatestud_detailsarr, setupdatestud_detailsarr] = useState();

    const [FamilyResult, setFamilyResult] = useState(false);
    const [campusSessions, setCampusSessions] = useState([]);
    const [canApplyParentHistory, setCanApplyParentHistory] = useState(false);
    const [parentHistoryApplied, setParentHistoryApplied] = useState(false);
    const [detailsLoaded, setDetailsLoaded] = useState(false);
    const [originalParentContact, setOriginalParentContact] = useState(null);
    const [tassParentContact, setTassParentContact] = useState(null);
    const [savedContactApplied, setSavedContactApplied] = useState(false);
    const [tassStudentMedical, setTassStudentMedical] = useState(null);
    const [baselineSaved, setBaselineSaved] = useState(false);
    // Children an earlier, paid re-enrolment already covered. The fee engine refuses to price them
    // whatever this page sends; this stops the page offering them as returning in the first place.
    const [alreadyReEnrolled, setAlreadyReEnrolled] = useState([]);
    // Children AIC Connect listed with this family who belong to another parent code at the same
    // campus. Their own parent code re-enrols them: a re-enrolment, its confirmation and its receipt
    // carry one parent code. Each is { stud_code, parent_code, college }.
    const [otherParentCodeChildren, setOtherParentCodeChildren] = useState([]);
    // The family's campuses already paid for, from the status: their children are re-enrolled, and
    // must not be offered "Enrolling" or "Leaving" again.
    const [paidCampuses, setPaidCampuses] = useState([]);
    const parentHistoryData = useSelector((state) => state.parentInfo.parentHistory);

    // Parent history is read here for the campus figures it carries — credit, and what each
    // campus is still owed for the current year. It used to be read to decide whether to turn the
    // family away; owing no longer stops anybody, it is collected on the payment page.
    const {
        data: queriedParentHistory,
        isSuccess: isParentHistorySuccess,
        isError: isParentHistoryError,
    } = useParentHistory(location.state?.ParentID);

    const isParentHistoryLoading = Boolean(location.state?.ParentID)
        && !isParentHistorySuccess && !isParentHistoryError;

    useEffect(() => {
        if (isParentHistorySuccess && queriedParentHistory != null) {
            dispatch(setParentHistory(queriedParentHistory));
        }
    }, [dispatch, isParentHistorySuccess, queriedParentHistory]);

    const [NumberInitial1, SetNumberInitial1] = useState('');
    const [NumberInitial2, SetNumberInitial2] = useState('');

    const [StudentMedicalDetails, SetStudentMedicalDetails] = useState([]);
    const [updatedMedicalRecords, SetupdatedMedicalRecords] = useState(null);

    const [, SetValidMedicare] = useState(false);
    const [, SetValidMedicareExpiry] = useState(false);
    
    // Family-level Medicare details (extracted from children or entered by parent)
    // The parent's own saved card, once it has been read back. Held in a ref as well as state
    // because the TASS records can arrive after it and must not overwrite it.
    const savedFamilyMedicareRef = useRef(null);
    const [ParentMedicareNumber, setParentMedicareNumber] = useState('');
    const [ParentMedicareExpiry, setParentMedicareExpiry] = useState('');
    const [OriginalParentMedicareNumber, setOriginalParentMedicareNumber] = useState('');
    const [OriginalParentMedicareExpiry, setOriginalParentMedicareExpiry] = useState('');
    const [ParentNoMedicare, setParentNoMedicare] = useState(false);

    // Derived, so a card prefilled from TASS is validated the same as a typed one.
    const ParentMedicareValid = /^\d{10}$/.test(ParentMedicareNumber || '');
    const ParentMedicareExpiryValid = isValidMonthYear(ParentMedicareExpiry);

    const [, SetValidAmbulanceCover] = useState(false);
    const [, SetValidImmunisationStatus] = useState(false);
    const [, SetValidAllergy] = useState(false);
    const [, SetValidPHI] = useState(false);
    const [Status, SetStatus] = useState('');
    const [LoadingModalOpen, setLoadingModalOpen] = useState(true);

    const [isLoading, SetisLoading] = useState(false);
    const [savingStatus, setSavingStatus] = useState('');

    const [EmptyFieldErrorOpen, SetEmptyFieldErrorOpen] = useState(false);
    const [isMedicareMandatoryFromTASS, SetIsMedicareMandatoryFromTASS] = useState(false);
    const [medicareImages, SetMedicareImages] = useState([]);
    const [studentMedicareImages, setStudentMedicareImagesState] = useState({});
    // What the backend already holds, so a parent who has uploaded their card sees it rather than
    // two empty boxes and a demand to do it again.
    const [familyStoredFiles, setFamilyStoredFiles] = useState([]);
    const [studentStoredFiles, setStudentStoredFiles] = useState({});
    // Slots the parent has cleared on screen to replace the picture in them.
    const [clearedFamilySlots, setClearedFamilySlots] = useState([]);
    const [clearedStudentSlots, setClearedStudentSlots] = useState({});

    const [snackBarData, setSnackBarData] = useState({
        is_enabled: false,
        message: '',
        variant: '',
    });

    const formik = useFormik({
        initialValues: {
            Email1: '',
            Email2: '',
            Number1: '',
            Number2: '',
            Town: '',
            State: '',
            Address1: '',
            Address2: '',
            Address3: '',
            PostCode: '',
            accepted: false,
        },
        validationSchema: parentFormSchema,
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: () => { },
    });

    const {
        Email1,
        Email2,
        Number1,
        Number2,
        Town,
        State,
        Address1,
        Address2,
        Address3,
        PostCode,
        accepted,
    } = formik.values;

    // Scroll to top when moving between wizard screens
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }, 50);
    }, [activeSubStep]);

    const currentParentContact = () => ({
        Email1,
        Email2,
        Number1: NumberInitial1 + Number1,
        Number2: NumberInitial2 + Number2,
        Town,
        State,
        Address1,
        Address2,
        Address3,
        PostCode,
    });

    const parentRecordStatusFields = () => getParentRecordStatusPayload({
        hasChanged: hasParentContactChanged(originalParentContact, currentParentContact()),
    });

    const insertLogFunc = async (parent, students) => {
        try {
            const emails = getParentEmails(parent);
            const insertLogResult = await URL2.post("/insertdatalog", {
                u_ParID: ParentID,
                college: getPrimaryCampusName(parent, ParentID),
                childrens: toReenrolmentChildren(students, parent.surname),
                famName: (parent.family_name || '').trim(),
                father_name: (parent.father_name || '').trim(),
                mother_name: (parent.mother_name || '').trim(),
                par_email: emails.combined,
                ref_page_complete: "No",
                feestruc_page_complete: "No",
                credit_amount: credit_amount,
                campusCredits: buildCampusCredits(parent),
                // The other half of the same wallet: what each campus is still owed for the
                // current year. Stored on the session so the figure the family was quoted
                // survives them leaving the page, and so the payment page does not have to
                // re-read parent history to know it.
                campusOutstanding: buildCampusOutstanding(parent),
            });
            if (insertLogResult) {
                setAlreadyReEnrolled(insertLogResult.data.alreadyReEnrolled || [])
                setOtherParentCodeChildren(insertLogResult.data.otherParentCodeChildren || [])
                setSessionID(insertLogResult.data.SessionID)
                setCampusSessions(insertLogResult.data.campusSessions || [])
                storeCampusSessions(insertLogResult.data.campusSessions || [])
                setupdatestud_detailsarr(insertLogResult.data.updatestud_detsarr)
                if (localStorage.getItem('LogID') === 'NA') {
                    localStorage.setItem('LogID', insertLogResult.data.SessionID);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (!alreadyReEnrolled.length) return;
        const covered = new Set(alreadyReEnrolled.map((code) => String(code).trim()));

        SetupdatedMedicalRecords((records) => (records || []).map((record) => (
            covered.has(String(record.student_code ?? record.stud_code ?? '').trim())
                ? { ...record, enrollStatus: 'Not Enrolled', alreadyReEnrolled: true }
                : record
        )));
    }, [alreadyReEnrolled]);

    // Applied again once the family's saved answers are back on the form (savedContactApplied): an
    // older save can carry "Enrolled" for such a child, and that would count them for this family.
    useEffect(() => {
        if (!otherParentCodeChildren.length) return;
        const theirs = new Map(otherParentCodeChildren.map((c) => [String(c.stud_code).trim(), c.parent_code]));

        SetupdatedMedicalRecords((records) => (records || []).map((record) => {
            const code = theirs.get(String(record.student_code ?? record.stud_code ?? '').trim());
            return code && (record.enrollStatus !== 'Not Enrolled' || record.otherParentCode !== code)
                ? { ...record, enrollStatus: 'Not Enrolled', otherParentCode: code }
                : record;
        }));
    }, [otherParentCodeChildren, savedContactApplied]);

    const savePersonalandMedDetailsFunc = async ({ rethrow = false } = {}) => {
        try {
            if (SessionID && detailsLoaded) {
                if (localStorage.getItem('LogID') === 'NA') {
                    localStorage.setItem('LogID', SessionID);
                }
                await URL2.post("/savePersonalandMedDetails", {
                    SessionID: SessionID,
                    campusSessions: campusSessions,
                    // parentaddold records what TASS held when the parent started, which is not
                    // the same as the form once their own saved values are back on it.
                    ...(tassParentContact || currentParentContact()),
                    ...parentRecordStatusFields(),
                    StudentMedicalDetails: toReenrolmentMedicalRecords(tassStudentMedical || StudentMedicalDetails),
                });
                setBaselineSaved(true);
            }
        }
        catch (error) {
            console.log(error);
            // The save step asks again before writing anything, and wants to know if it failed.
            if (rethrow) throw error;
        }
    };

    const setUpdateMedicalRecordsFunc = (formData) => {
        SetupdatedMedicalRecords(formData);
    };

    const isRecordEnrolled = (record, child) => {
        if (child && !isEligibleForReenrolment(child)) return false;
        if (!record) return Boolean(child && isEligibleForReenrolment(child));
        return record.enrollStatus !== 'Not Enrolled';
    };

    if (localStorage.getItem("LoginToken") !== null) {
        ParentID = location.state.ParentID;
        credit_amount = location.state.credit_amount;
        isGhostLogin = location.state.isGhostLogin;
    }

    const navigateToReenrolment = (enrolledchildrens1) => {
        const legacyChildren = toReenrolmentChildren(childrens, famName).map((child) => ({
            ...child,
            year_grp: child.year_grp + 1,
        }));
        const state = {
            ParentID: ParentID,
            famName: famName,
            par_email: par_email,
            childrens: legacyChildren,
            enrolledchildrens: enrichEnrolledChildrenWithCampus(enrolledchildrens1, childrens),
            updatestud_detailsarr: updatestud_detailsarr,
            college: college,
            credit_amount: credit_amount,
            SessionID: SessionID,
            campusSessions: campusSessions,
            isGhostLogin: isGhostLogin
        }
        navigate('/reenrolment', {
            state: state,
        });
    }

    /**
     * Apply the family-level Medicare number/expiry (entered once by the parent)
     * onto each child record that has not been given its own card details.
     */
    const applyFamilyMedicare = (records) =>
        (records || []).map((record) => {
            if (record.hasCustomMedicare || record.istemporaryVisa || ParentNoMedicare) {
                return record;
            }
            const parsed = splitMedicareNumber(record.medicare_number);
            const ref = record.medicare_ref_no || parsed.ref;
            return {
                ...record,
                medicare_number: ParentMedicareNumber && ref
                    ? `${ParentMedicareNumber}#${ref}`
                    : record.medicare_number,
                medicare_expiry: ParentMedicareExpiry || record.medicare_expiry,
            };
        });

    // Kept separate from the save step so the same upload can be started as soon as the parent
    // picks the two photos, and simply awaited later.
    const postFamilyMedicare = useCallback((files) => {
        const formData = new FormData();
        formData.append('Parent_ID', ParentID);
        formData.append('college', college);
        formData.append('card_type', 'family');
        formData.append('student_id', '');
        // The card these pictures are evidence of. Without it, changing the number later would
        // leave the old pictures counting as proof of the new card.
        formData.append('medicare_number', ParentMedicareNumber || '');
        formData.append('medicare_expiry', ParentMedicareExpiry || '');

        files.forEach((file, index) => {
            if (!file) return;
            const fileExtension = file.name.split('.').pop();
            const side = index === 0 ? 'Front' : 'Back';
            const renamedFile = new File([file], `${ParentID}-Family-Medicare-${side}.${fileExtension}`);
            formData.append("files", renamedFile);
        });

        return URL2.post("/upload/Medicare-card", formData);
    }, [ParentID, college, ParentMedicareNumber, ParentMedicareExpiry]);

    const familyMedicareKey = uploadKey(`family:${ParentID}`, medicareImages);

    const postStudentMedicare = useCallback((studentCode, campus, files, card = {}) => {
        const formData = new FormData();
        formData.append('Parent_ID', ParentID);
        formData.append('college', campus || college);
        formData.append('card_type', 'student');
        formData.append('student_id', studentCode);
        formData.append('student_code', studentCode);
        formData.append('medicare_number', card.number || '');
        formData.append('medicare_expiry', card.expiry || '');

        files.forEach((file, fileIndex) => {
            if (!file) return;
            const extension = file.name.split('.').pop();
            const side = fileIndex === 0 ? 'Front' : 'Back';
            const renamedFile = new File(
                [file],
                `${studentCode}-Medicare-${side}.${extension}`,
                { type: file.type }
            );
            formData.append('files', renamedFile);
        });

        return URL2.post('/upload/Medicare-card', formData);
    }, [ParentID, college]);



    const UpdatePersonalandMedDetails = async () => {
        try {
            setSnackBarData({
                is_enabled: false,
                message: '',
                variant: '',
            });

            if (!isGhostLogin) {
                SetisLoading(true);
                setSavingStatus('Saving your details. Please wait...');

                // Medicare card upload requirement. A side already on file for this card counts:
                // the screen shows it, so demanding it again here contradicts what the parent is
                // looking at.
                if (familyUploadRequired) {
                    if (cardSideMissing(medicareImages, familyStoredCard)) {
                        SetisLoading(false);
                        setSavingStatus('');
                        setSnackBarData({
                            is_enabled: true,
                            message: 'Enter valid Medicare details, then upload both the front and back of the updated card.',
                            variant: 'error',
                        });

                        setTimeout(() => {
                            setSnackBarData({
                                is_enabled: false,
                                message: '',
                                variant: '',
                            });
                        }, 6000);

                        return;
                    }

                    // Usually already finished: it started when the photos were picked, several
                    // screens back. Awaiting the same promise avoids uploading them twice, and
                    // falls back to uploading here if the background attempt failed.
                    // Nothing new was picked, so what is on file is the card being claimed and
                    // there is nothing to send.
                    if (medicareImages.some(Boolean)) {
                        setSavingStatus('Uploading Medicare card images. Please wait...');
                        const response = await (
                            pendingBackgroundUpload(familyMedicareKey)
                            || startBackgroundUpload(familyMedicareKey, () => postFamilyMedicare(medicareImages))
                            || postFamilyMedicare(medicareImages)
                        );
                        if (response.status === 200) {
                            setSnackBarData({
                                is_enabled: true,
                                message: response.data.message,
                                variant: 'success',
                            });
                        }
                    }
                }

                // Keep each different student card separate on the backend.
                const customCardStudents = (updatedMedicalRecords || []).filter(
                    (record) =>
                        record.enrollStatus !== 'Not Enrolled' &&
                        !record.istemporaryVisa &&
                        (record.hasCustomMedicare || ParentNoMedicare)
                );

                if (customCardStudents.length > 0) {
                    setSavingStatus('Uploading student Medicare card images. Please wait...');
                }

                await Promise.all(customCardStudents.map(async (record, index) => {
                    const studentCode = childCode(record) || String(index);
                    const files = studentMedicareImages[studentCode] || [];
                    const stored = studentStoredCards[studentCode] || emptyCardSlots();

                    if (cardSideMissing(files, stored)) {
                        throw new Error(`Upload both sides of the Medicare card for ${childFullName(record) || 'each student'}.`);
                    }

                    // Already on file and nothing new chosen: there is nothing to send.
                    if (!files.some(Boolean)) return;

                    // Usually started as soon as the photos were picked; await that rather than
                    // uploading the same card a second time.
                    const key = studentCardKey(ParentID, studentCode, files);
                    const inFlight = pendingBackgroundUpload(key);
                    await (inFlight || postStudentMedicare(studentCode, record.campus_name, files, {
                        number: record.medicare_number,
                        expiry: record.medicare_expiry,
                    }));
                }));

                const medicalRecords = applyFamilyMedicare(updatedMedicalRecords);

                setSavingStatus('Saving your details. Please wait...');
                await URL2.post("/updatePersonalandMedDetails", buildPersonalandMedPayload({
                    ParentID,
                    SessionID,
                    campusSessions,
                    contact: currentParentContact(),
                    recordStatus: parentRecordStatusFields(),
                    medicalRecords,
                }));

                const enrolledchildrens1 = buildEnrolledChildrenFromForm(
                    childrens,
                    medicalRecords,
                    famName
                );

                setenrolledchildrens(enrolledchildrens1);
                SetisLoading(false);
                setSavingStatus('');
                navigateToReenrolment(enrolledchildrens1);
            }

            else if (isGhostLogin) {
                const legacyChildren = toReenrolmentChildren(childrens, famName).map((child) => ({
                    ...child,
                    year_grp: child.year_grp + 1,
                }));
                const state = {
                    ParentID: ParentID,
                    famName: famName,
                    par_email: par_email,
                    childrens: legacyChildren,
                    enrolledchildrens: legacyChildren,
                    updatestud_detailsarr: updatestud_detailsarr,
                    college: college,
                    credit_amount: credit_amount,
                    SessionID: SessionID,
                    campusSessions: campusSessions,
                    isGhostLogin: isGhostLogin
                }

                navigate('/reenrolment', {
                    state: state,
                });
            }
        }
        catch (error) {
            SetisLoading(false);
            setSavingStatus('');

            let errorMessage = 'An error occurred. Please try again.';

            if (error.response) {
                if (error.response.status === 400) {
                    errorMessage = error.response.data?.message || 'Invalid request. Please check your information and try again.';
                } else if (error.response.status === 500) {
                    errorMessage = 'Server error. Please try again later.';
                } else if (error.response.data?.message) {
                    errorMessage = error.response.data.message;
                }
            } else if (error.message) {
                errorMessage = error.message;
            }

            setSnackBarData({
                is_enabled: true,
                message: errorMessage,
                variant: 'error',
            });

            setTimeout(() => {
                setSnackBarData({
                    is_enabled: false,
                    message: '',
                    variant: '',
                });
            }, 6000);
        }
    };

    /**
     * Populate the form from the parent-history payload (development replaced
     * the legacy personal-details and family-details endpoints with /parent/get-parent-history).
     */
    const applyParentContactAndMedical = (parent) => {
        const contact = parent.contact || {};
        const address = parent.address || {};

        const numberInitial1 = contact.mobile1 == null ? '(M)' : (contact.mobile1.match(/\(.*?\)/)?.[0] || '');
        const numberInitial2 = contact.mobile2 == null ? '(F)' : (contact.mobile2.match(/\(.*?\)/)?.[0] || '');
        const number1 = contact.mobile1 == null ? '' : contact.mobile1.replace(/\(.*?\)/g, '').replace(/\s/g, '');
        const number2 = contact.mobile2 == null ? '' : contact.mobile2.replace(/\(.*?\)/g, '').replace(/\s/g, '');
        const email1 = contact.email1 == null ? '' : contact.email1.trim();
        const email2 = contact.email2 == null ? '' : contact.email2.trim();
        const address1 = address.address_line1 == null ? '' : address.address_line1;
        const address2 = address.address_line2 == null ? '' : address.address_line2;
        const address3 = address.address_line3 == null ? '' : address.address_line3;
        const town = address.town_suburb == null ? '' : address.town_suburb;
        const postCode = address.postcode == null ? '' : address.postcode;
        const state = address.state == null ? '' : String(address.state);

        SetNumberInitial1(numberInitial1);
        SetNumberInitial2(numberInitial2);

        formik.setValues({
            Email1: email1,
            Email2: email2,
            Number1: number1,
            Number2: number2,
            Address1: address1,
            Address2: address2,
            Address3: address3,
            Town: town,
            PostCode: postCode,
            State: state,
            accepted: false,
        }, true);
        const tassContact = {
            Email1: email1,
            Email2: email2,
            Number1: numberInitial1 + number1,
            Number2: numberInitial2 + number2,
            Town: town,
            State: state,
            Address1: address1,
            Address2: address2,
            Address3: address3,
            PostCode: postCode,
        };

        setOriginalParentContact(snapshotParentContactRecord(tassContact));
        // Kept unnormalised as well, because parentaddold stores what TASS had, not what is on
        // screen once the parent's own saved values have been put back.
        setTassParentContact(tassContact);
        setDetailsLoaded(true);

        const students = flattenParentStudents(parent).map((student) => {
            const parsed = splitMedicareNumber(student.medicare_number);
            const medicareRef = String(student.medicare_ref_no ?? '').trim() || parsed.ref;
            return {
                ...student,
                enrollStatus: isEligibleForReenrolment(student) ? 'Enrolled' : 'Not Enrolled',
                medicare_ref_no: /^\d$/.test(medicareRef) ? medicareRef : student.medicare_ref_no,
                medicare_number: parsed.base && medicareRef
                    ? `${parsed.base}#${medicareRef}`
                    : student.medicare_number,
            };
        });
        SetStudentMedicalDetails(students);
        SetupdatedMedicalRecords(students);
        // stud_medold records what TASS had, so the baseline write must not use the records once
        // the parent's own saved answers are back on them.
        setTassStudentMedical(students);

        // Family-level Medicare number: retain the original value so changing
        // either card field can require fresh front/back evidence.
        const familyMedicareRecord = students.find(
            (record) => record.medicare_number
                && !record.istemporaryVisa
                && !record.temporary_visa
        );
        const initialMedicareNumber = familyMedicareRecord
            ? getMedicareBase(familyMedicareRecord.medicare_number)
            : '';
        // The baseline is always what the school holds — that is what "changed" is measured
        // against. What the parent sees is their own saved answer when they have one.
        setParentMedicareNumber(savedFamilyMedicareRef.current?.number || initialMedicareNumber);
        setOriginalParentMedicareNumber(initialMedicareNumber);

        const medicare_expiry = students
            .map((data) => data.medicare_expiry)
            .filter(Boolean);

        if (medicare_expiry.length > 0) {
            const latestExpiryDate = medicare_expiry
                .map(parseMonthYear)
                .filter(Boolean)
                .sort((a, b) => b - a)[0];

            if (latestExpiryDate) {
                const mm = String(latestExpiryDate.getMonth() + 1).padStart(2, '0');
                const yyyy = latestExpiryDate.getFullYear();
                setParentMedicareExpiry(savedFamilyMedicareRef.current?.expiry || `${mm}/${yyyy}`);
                setOriginalParentMedicareExpiry(`${mm}/${yyyy}`);
            } else {
                const invalidExpiry = String(medicare_expiry[0] || '');
                setParentMedicareExpiry(savedFamilyMedicareRef.current?.expiry || invalidExpiry);
                setOriginalParentMedicareExpiry(invalidExpiry);
            }

            const currentMonth = new Date();
            const currentMonthStart = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
            const medicareMandatoryFromTass =
                !latestExpiryDate || latestExpiryDate <= currentMonthStart;
            SetIsMedicareMandatoryFromTASS(medicareMandatoryFromTass);
        } else {
            setOriginalParentMedicareExpiry('');
            SetIsMedicareMandatoryFromTASS(true);
        }

        return students;
    };

    const handleAgreeChange = (event) => {
        formik.setFieldValue('accepted', event.target.checked);
    };

    useEffect(() => {
        setLoadingModalOpen(true);

        if (isGhostLogin) {
            setCanApplyParentHistory(true);
            return;
        }

        const init = async () => {
            try {
                if (!localStorage.getItem("LoginToken")) {
                    navigate('/');
                    return;
                }

                const data = await checkStatus().catch(err => {
                    console.error("An error occurred:", err);
                    return null;
                });

                const renrolStatus = data?.RenrolStatus ?? "Initiated";
                SetStatus(renrolStatus);

                // A submitted re-enrolment can still owe a campus payment. Those
                // families skip the form and go back to the fee page for the
                // remaining charges whenever there is enough saved context.
                const resumePaymentState = resolveCampusPaymentResume(data, { ParentID });
                if (resumePaymentState) {
                    navigate('/payment', { replace: true, state: resumePaymentState });
                    return;
                }

                // No saved context in this browser, but a campus paid and another owing: the server
                // rebuilds it, so the family pays what is left instead of answering everything again.
                if (hasOutstandingCampusPayment(data)) {
                    const resumeAt = await paymentContextOnServer(ParentID);
                    if (resumeAt.context) {
                        navigate('/payment', { replace: true, state: { ...location.state, ...resumeAt.context } });
                        return;
                    }
                }
                setPaidCampuses((data?.campusStatuses || []).filter((campus) => campus?.paid));

                if (shouldRedirectToCompletion(data)) {
                    navigate('/reenrolmentcompleted', {
                        state: {
                            t_date: data.t_date,
                            t_time: data.t_time,
                            campusStatuses: data.campusStatuses || [],
                        }
                    });
                    return;
                }

                setCanApplyParentHistory(true);
            } catch (error) {
                console.error("Unexpected error:", error);
                setLoadingModalOpen(false);
            }
        };

        init();
    }, [ParentID, isGhostLogin, navigate]);

    useEffect(() => {
        if (!canApplyParentHistory) return;

        if (parentHistoryData == null) {
            if (!isParentHistoryLoading) {
                setLoadingModalOpen(false);
            }
            return;
        }

        if (parentHistoryData === 'No children found') {
            setFamilyResult(false);
            setLoadingModalOpen(false);
            return;
        }

        if (parentHistoryApplied) {
            setLoadingModalOpen(false);
            return;
        }

        const parent = parentHistoryData;
        const students = applyParentContactAndMedical(parent);
        const emails = getParentEmails(parent);

        setFamilyResult(true);
        setfamName((parent.family_name || '').trim());
        setchildrens(students);
        setCollege(getPrimaryCampusName(parent, ParentID));
        setpar_email(emails.combined);
        setParentHistoryApplied(true);
        setLoadingModalOpen(false);

        if (!isGhostLogin) {
            insertLogFunc(parent, students);
        }
    }, [
        canApplyParentHistory,
        parentHistoryData,
        parentHistoryApplied,
        isGhostLogin,
        ParentID,
        isParentHistoryLoading,
    ]);

    // A parent who saved and came back continues from their own values. The form was rebuilt from
    // TASS a moment ago, so their earlier edits go back on top of it; the TASS snapshot above is
    // left alone, because that is what "did anything change" is measured against.
    useEffect(() => {
        if (isGhostLogin || !SessionID || !detailsLoaded || savedContactApplied) return;

        let ignore = false;

        const applySavedContact = async () => {
            try {
                const response = await URL2.get('/fetchSavedParentDetails', {
                    params: {
                        SessionID,
                        SessionIDs: (campusSessions || []).map((s) => s.SessionID).filter(Boolean).join(','),
                    },
                });
                const saved = formValuesFromSavedContact(response?.data?.ParentContact);

                if (ignore) return;

                if (saved) {
                    SetNumberInitial1(saved.numberInitial1);
                    SetNumberInitial2(saved.numberInitial2);
                    formik.setValues({ ...formik.values, ...saved.values }, true);
                }

                const savedMedical = response?.data?.StudentMedical;
                if (savedMedical?.length) {
                    SetStudentMedicalDetails((current) => mergeSavedStudentMedical(current, savedMedical));
                    SetupdatedMedicalRecords((current) => mergeSavedStudentMedical(current, savedMedical));

                    // The card number and expiry are saved onto each child, never against the
                    // family, so they have to be read back out. Without this the school's old
                    // number reappears every time the parent returns — and the next save writes
                    // it back over the one they entered.
                    const savedFamily = familyMedicareFromRecords(savedMedical);
                    savedFamilyMedicareRef.current = savedFamily;
                    if (savedFamily.number) setParentMedicareNumber(savedFamily.number);
                    if (savedFamily.expiry) setParentMedicareExpiry(savedFamily.expiry);
                }
            } catch (error) {
                // Nothing saved to put back, or it could not be read — the TASS values stay on
                // the form, which is what the parent saw before this existed.
                console.log(error);
            } finally {
                if (!ignore) setSavedContactApplied(true);
            }
        };

        applySavedContact();

        return () => { ignore = true; };
    }, [SessionID, detailsLoaded, savedContactApplied, isGhostLogin]);

    useEffect(() => {
        if (isGhostLogin || !SessionID || !detailsLoaded) return;

        const timer = setTimeout(() => {
            savePersonalandMedDetailsFunc();
        }, 600);

        return () => clearTimeout(timer);
    }, [SessionID, campusSessions, detailsLoaded, Email1, Email2, Number1, Number2, NumberInitial1, NumberInitial2, Town, State, Address1, Address2, Address3, PostCode, originalParentContact, isGhostLogin]);

    const handleChildEnrollToggle = (index, newStatus) => {
        const sourceRecords = (updatedMedicalRecords?.length
            ? updatedMedicalRecords
            : null)
            || (StudentMedicalDetails?.length ? StudentMedicalDetails : null)
            || childrens
            || [];

        // Always keep one row per child so selecting a single student cannot
        // collapse the list or leave Next stuck on a stale empty selection.
        const updated = (childrens || []).map((child, idx) => {
            const existing = sourceRecords[idx] || child;
            const currentStatus = existing.enrollStatus
                ?? (isEligibleForReenrolment(child) ? 'Enrolled' : 'Not Enrolled');

            return {
                ...existing,
                enrollStatus: idx === index
                    ? newStatus
                    : (isEligibleForReenrolment(child) ? currentStatus : 'Not Enrolled'),
            };
        });

        SetupdatedMedicalRecords(updated);
        SetStudentMedicalDetails(updated);
    };

    const medicalRecords = (updatedMedicalRecords?.length
        ? updatedMedicalRecords
        : null)
        || StudentMedicalDetails
        || [];

    /**
     * The family card pictures that prove the card currently on screen.
     *
     * A picture is evidence of one card. Change the number or the expiry and the old picture
     * proves nothing about the new card, so it is not shown and a fresh one is required. A
     * picture with no card recorded against it counts only for the card the school holds.
     */
    const familyStoredCard = useMemo(() => {
        const slots = slotsFromStoredFiles(familyStoredFiles, {
            current: { number: ParentMedicareNumber, expiry: ParentMedicareExpiry },
            original: { number: OriginalParentMedicareNumber, expiry: OriginalParentMedicareExpiry },
        });

        return slots.map((slot, index) => (clearedFamilySlots[index] ? null : slot));
    }, [
        familyStoredFiles,
        clearedFamilySlots,
        ParentMedicareNumber,
        ParentMedicareExpiry,
        OriginalParentMedicareNumber,
        OriginalParentMedicareExpiry,
    ]);

    /** The same, per student, against the card on that student's record. */
    const studentStoredCards = useMemo(() => {
        const byStudent = {};

        Object.entries(studentStoredFiles).forEach(([code, files]) => {
            const record = (medicalRecords || []).find((item) => childCode(item) === code);
            const slots = slotsFromStoredFiles(files, {
                current: { number: record?.medicare_number, expiry: record?.medicare_expiry },
            });
            const cleared = clearedStudentSlots[code] || [];
            byStudent[code] = slots.map((slot, index) => (cleared[index] ? null : slot));
        });

        return byStudent;
    }, [studentStoredFiles, clearedStudentSlots, medicalRecords]);

    const medicareOptions = useMemo(() => ({
        parentNoMedicare: ParentNoMedicare,
        parentMedicareNumber: ParentMedicareNumber,
        parentMedicareExpiry: ParentMedicareExpiry,
    }), [ParentNoMedicare, ParentMedicareNumber, ParentMedicareExpiry]);

    const familyMedicareErrors = useMemo(
        () => getFamilyMedicareErrors({
            noMedicare: ParentNoMedicare,
            number: ParentMedicareNumber,
            expiry: ParentMedicareExpiry,
        }),
        [ParentNoMedicare, ParentMedicareNumber, ParentMedicareExpiry]
    );

    const familyMedicareChanged =
        String(ParentMedicareNumber || '').replace(/\D/g, '') !==
            String(OriginalParentMedicareNumber || '').replace(/\D/g, '') ||
        (() => {
            const current = parseMonthYear(ParentMedicareExpiry);
            const original = parseMonthYear(OriginalParentMedicareExpiry);
            if (current && original) {
                return current.getTime() !== original.getTime();
            }
            return String(ParentMedicareExpiry || '').trim() !== String(OriginalParentMedicareExpiry || '').trim();
        })();
    const familyUploadRequired =
        !ParentNoMedicare && (isMedicareMandatoryFromTASS || familyMedicareChanged);
    // A card already on file counts: the expiry TASS holds does not change until the back office
    // processes the card, so without this a returning parent is asked for it over and over.
    const familyUploadError = familyUploadRequired && cardSideMissing(medicareImages, familyStoredCard)
        ? 'Medicare Front and Back Images are required'
        : '';

    // Send the family card as soon as both sides are on screen. The parent then walks through the
    // student screens while it uploads, instead of waiting for it at "Save & Next".
    useEffect(() => {
        if (!familyUploadRequired || !familyMedicareKey) return;
        if (!readyToUpload(medicareImages, familyStoredCard)) return;

        startBackgroundUpload(familyMedicareKey, () => postFamilyMedicare(medicareImages));
    }, [familyUploadRequired, familyMedicareKey, medicareImages, familyStoredCard, postFamilyMedicare]);

    // Ask what is already stored when the screen opens. Nothing did before, which is the whole
    // reason parents kept uploading the same card.
    useEffect(() => {
        if (!ParentID) return undefined;

        let ignore = false;
        fetchFamilyMedicareFiles(ParentID).then((files) => {
            if (!ignore) setFamilyStoredFiles(files);
        });

        return () => { ignore = true; };
    }, [ParentID]);

    /** Students re-enrolling on their own Medicare card rather than the family one. */
    const ownCardStudents = useMemo(
        () => (medicalRecords || [])
            .filter((record) => record.enrollStatus !== 'Not Enrolled'
                && !record.istemporaryVisa
                && (record.hasCustomMedicare || ParentNoMedicare))
            .map((record) => ({
                code: childCode(record),
                campus: record.campus_name,
                card: { number: record.medicare_number, expiry: record.medicare_expiry },
            }))
            .filter((student) => student.code),
        [medicalRecords, ParentNoMedicare]
    );
    const ownCardStudentCodes = ownCardStudents.map((student) => student.code).join(',');

    useEffect(() => {
        if (!ParentID || !ownCardStudentCodes) return undefined;

        let ignore = false;
        Promise.all(ownCardStudentCodes.split(',').map(async (code) => [
            code,
            await fetchStudentMedicareFiles(ParentID, code),
        ])).then((pairs) => {
            if (!ignore) {
                setStudentStoredFiles((current) => ({ ...current, ...Object.fromEntries(pairs) }));
            }
        });

        return () => { ignore = true; };
    }, [ParentID, ownCardStudentCodes]);

    // Send a student's card as soon as both sides are on screen, exactly as the family card is
    // sent. It used to wait until "Save & Next", so a slow upload held up the whole form.
    useEffect(() => {
        ownCardStudents.forEach(({ code, campus, card }) => {
            const files = studentMedicareImages[code] || [];
            if (!readyToUpload(files, studentStoredCards[code] || emptyCardSlots())) return;

            const key = studentCardKey(ParentID, code, files);
            if (key) startBackgroundUpload(key, () => postStudentMedicare(code, campus, files, card));
        });
    }, [ParentID, ownCardStudents, studentMedicareImages, studentStoredCards, postStudentMedicare]);
    const familyStepErrors = [
        ...familyMedicareErrors,
        ...(familyUploadError ? [familyUploadError] : []),
    ];

    const familyMedicareExpired =
        !ParentNoMedicare
        && isValidMonthYear(ParentMedicareExpiry)
        && !isMonthYearInFuture(ParentMedicareExpiry);

    /**
     * Only students being re-enrolled get a medical screen. A family that
     * re-enrols one of three children answers one medical form, not three.
     */
    const enrolledStudentIndexes = useMemo(
        () => (childrens || []).reduce((indexes, child, index) => {
            if (isRecordEnrolled(medicalRecords[index], child)) {
                indexes.push(index);
            }
            return indexes;
        }, []),
        [childrens, medicalRecords]
    );

    const noStudentSelected = enrolledStudentIndexes.length === 0;
    const totalMedicalScreens = enrolledStudentIndexes.length;
    const currentStudentIndex = activeSubStep > 0 ? enrolledStudentIndexes[activeSubStep - 1] : -1;

    /** Outstanding fields per enrolled student, so a blocked Next can say why. */
    const studentIssues = useMemo(
        () => enrolledStudentIndexes.map((studentIndex, screen) => ({
            screen: screen + 1,
            studentIndex,
            name: childFullName(childrens?.[studentIndex]) || `Student ${screen + 1}`,
            errors: getStudentMedicalErrors(medicalRecords[studentIndex], {
                ...medicareOptions,
                studentMedicareImages:
                    studentMedicareImages[childCode(medicalRecords[studentIndex]) || studentIndex] || [],
                studentStoredCard:
                    studentStoredCards[childCode(medicalRecords[studentIndex])] || emptyCardSlots(),
            }),
        })),
        [enrolledStudentIndexes, childrens, medicalRecords, medicareOptions, studentMedicareImages, studentStoredCards]
    );

    const currentStudentErrors =
        studentIssues.find((issue) => issue.studentIndex === currentStudentIndex)?.errors || [];
    const incompleteStudents = studentIssues.filter((issue) => issue.errors.length > 0);

    const parentContactErrors = useMemo(
        () => (detailsLoaded ? getParentContactErrors(formik.values) : []),
        [detailsLoaded, formik.values]
    );
    const personalContactErrors = parentContactErrors.filter((error) => error.section === 'personal');
    const addressContactErrors = parentContactErrors.filter((error) => error.section === 'address');
    const parentErrorByField = useMemo(() => {
        const map = {};
        parentContactErrors.forEach((error) => {
            map[error.field] = error.message;
        });
        return map;
    }, [parentContactErrors]);

    const showParentFieldError = (name) => Boolean(
        (formik.touched[name] || attemptedStep0Next) && parentErrorByField[name]
    );
    const parentFieldHelper = (name) => (showParentFieldError(name) ? parentErrorByField[name] : '');

    const scrollToId = (id) => {
        window.requestAnimationFrame(() => {
            document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    };

    // Unselecting a child shortens the wizard; never strand the user past the end.
    useEffect(() => {
        if (activeSubStep > totalMedicalScreens) {
            setActiveSubStep(totalMedicalScreens);
        }
    }, [activeSubStep, totalMedicalScreens]);

    /**
     * StudentMedicalForm rebuilds its own state from StudentMedicalDetails whenever
     * it remounts, so answers have to be committed before leaving the current screen.
     */
    /**
     * Saves what the parent has entered so far, without holding up the screen. The endpoint only
     * upserts — no emails, no status changes — so it is safe on every screen, and the save at the
     * end is still the authoritative one. Answers stop living only in the browser.
     */
    const saveProgress = async (records) => {
        if (isGhostLogin || !SessionID || !detailsLoaded || !records?.length) return;

        try {
            // Never the parent's values without what TASS had to compare them against.
            if (!baselineSaved) {
                await savePersonalandMedDetailsFunc({ rethrow: true });
            }

            await URL2.post("/updatePersonalandMedDetails", buildPersonalandMedPayload({
                ParentID,
                SessionID,
                campusSessions,
                contact: currentParentContact(),
                recordStatus: parentRecordStatusFields(),
                medicalRecords: applyFamilyMedicare(records),
            }));
        } catch (error) {
            // The parent keeps going; the save at the end writes everything again.
            console.log('Could not save progress:', error?.message);
        }
    };

    const goToStudentScreen = (screen) => {
        if (updatedMedicalRecords) {
            SetStudentMedicalDetails(updatedMedicalRecords);
            saveProgress(updatedMedicalRecords);
        }
        setActiveSubStep(screen);
    };

    const markParentFieldsTouched = () => {
        formik.setTouched({
            Email1: true,
            Email2: true,
            Number1: true,
            Number2: true,
            Address1: true,
            Address2: true,
            Address3: true,
            Town: true,
            PostCode: true,
            State: true,
        }, false);
    };

    const highlightParentStepErrors = (errors = parentContactErrors) => {
        setAttemptedStep0Next(true);
        markParentFieldsTouched();
        if (errors.some((error) => error.section === 'personal')) {
            setIsEditingPersonal(true);
        }
        if (errors.some((error) => error.section === 'address')) {
            setIsEditingAddress(true);
        }

        const firstParent = errors[0];
        const targetId = firstParent
            ? `parent-field-${firstParent.field}`
            : familyStepErrors.length
                ? 'family-medicare-section'
                : 'student-selection-section';
        setTimeout(() => scrollToId(targetId), 150);
    };

    const handleParentStepNext = async () => {
        await formik.validateForm();
        const errors = getParentContactErrors(formik.values);
        if (errors.length || familyStepErrors.length || noStudentSelected) {
            highlightParentStepErrors(errors);
            return;
        }
        goToStudentScreen(1);
    };

    const handleStudentStepNext = () => {
        if (currentStudentErrors.length > 0) {
            scrollToId(`student-field-${currentStudentErrors[0].field}`);
            return;
        }
        goToStudentScreen(activeSubStep + 1);
    };

    const handleSaveAndNext = async () => {
        if (isLoading) return;

        await formik.validateForm();
        const errors = getParentContactErrors(formik.values);
        if (errors.length) {
            goToStudentScreen(0);
            highlightParentStepErrors(errors);
            return;
        }
        if (currentStudentErrors.length > 0 || incompleteStudents.length > 0) {
            const issue = currentStudentErrors[0] || incompleteStudents[0]?.errors?.[0];
            if (issue?.field) {
                scrollToId(`student-field-${issue.field}`);
            }
            return;
        }
        if (!accepted) {
            setSnackBarData({
                is_enabled: true,
                message: 'Please confirm you have reviewed the information.',
                variant: 'error',
            });
            return;
        }
        SetisLoading(true);
        setSavingStatus('Saving your details. Please wait...');
        UpdatePersonalandMedDetails();
    };

    const setStudentMedicareImages = (studentCode, files) => {
        setStudentMedicareImagesState((current) => ({
            ...current,
            [studentCode]: files,
        }));
    };

    const missingInfoAlert = (title, messages) => (
        <Alert
            severity="warning"
            icon={<WarningAmberRoundedIcon fontSize="inherit" />}
            sx={{
                mb: 2,
                borderRadius: '12px',
                alignItems: 'flex-start',
                bgcolor: '#FFFBEB',
                border: '1px solid #FCD34D',
                color: '#92400E',
                '& .MuiAlert-icon': { color: '#D97706', pt: 0.25 },
            }}
        >
            <Typography sx={{ fontWeight: 700, fontSize: '13.5px', mb: 0.5 }}>{title}</Typography>
            <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                {messages.map((message) => (
                    <Typography component="li" key={message} sx={{ fontSize: '13px' }}>
                        {message}
                    </Typography>
                ))}
            </Box>
        </Alert>
    );

    const content = !FamilyResult ? (
        <Message />
    ) : (
        <>
            {snackBarData.is_enabled && (
                <CustomSnackbar
                    message={snackBarData.message}
                    variant={snackBarData.variant}
                />
            )}
            {/* Screen 1: Parent Details & Student Selection */}
            {activeSubStep === 0 && (
                <Box>
                    {/* Back to the introduction, and only on this sub-step: the medical screens below
                        have their own back button ("Back to Parent Details" / "Previous Student"), and
                        two back buttons on one screen would be a guess as to which one moves where.
                        Not to /code-of-conduct — accepting it is a one-time gate, and sending a parent
                        back there would ask them to accept it again. */}
                    <Box sx={{ mb: { xs: 1, sm: 1.5 } }}>
                        <StepBackButton to="/introduction" label="Back" />
                    </Box>

                    <ParentDetails
                        ParentID={ParentID}
                        college={college}
                famName={famName}
                childrens={childrens}
            />

            <Box sx={{ mb: 3, textAlign: 'center' }}>
                <Chip
                    label="Step 2 of 7"
                    size="small"
                    sx={{ bgcolor: '#ECFDF5', color: '#065F46', fontWeight: 700, fontSize: '12px', mb: 1, border: '1px solid #A7F3D0' }}
                />
                <Typography variant="h5" component="h1" sx={{ fontWeight: 800, color: '#0F172A', fontSize: { xs: '1.35rem', sm: '1.75rem' }, mb: 0.75 }}>
                    Parent & Student Information
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748B', fontSize: { xs: '13px', sm: '14.5px' }, maxWidth: 640, mx: 'auto' }}>
                    Please review your contact details, address, and student medical records below. Update any missing fields before continuing.
                </Typography>
            </Box>

            <Box className={classes.formouterBox}>
                <Grid sx={{ display: 'flex' }} container mt={0} spacing={2}>
                    <Grid item xs={12}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.25,
                            width: '100%',
                            backgroundColor: '#F8FAFC',
                            border: '1px solid #E2E8F0',
                            borderRadius: '12px',
                            padding: '10px 16px',
                            mt: 1,
                            mb: 2,
                        }}>
                            <Box sx={{ width: 4, height: 20, bgcolor: '#059669', borderRadius: 2 }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0F172A', fontSize: { xs: '14.5px', sm: '16px' }, flex: 1 }}>
                                Personal Contact Details
                            </Typography>
                            <Button
                                size="small"
                                startIcon={<ModeEditOutlineTwoToneIcon />}
                                onClick={() => setIsEditingPersonal(!isEditingPersonal)}
                                sx={{
                                    color: '#059669',
                                    fontWeight: 700,
                                    textTransform: 'none',
                                    bgcolor: 'rgba(5, 150, 105, 0.08)',
                                    borderRadius: '8px',
                                    px: 1.5,
                                    '&:hover': { bgcolor: 'rgba(5, 150, 105, 0.15)' }
                                }}
                            >
                                {isEditingPersonal ? "Done" : "Change"}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

                {!isEditingPersonal ? (
                    <Box
                        id="parent-field-Email1"
                        sx={{
                            p: 2,
                            borderRadius: '12px',
                            bgcolor: personalContactErrors.length ? '#FEF2F2' : '#F8FAFC',
                            border: personalContactErrors.length ? '1.5px solid #EF4444' : '1px solid #E2E8F0',
                            mb: 2
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 600, display: 'block' }}>
                                    Primary Email (Email 1)
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 700, color: '#0F172A' }}>
                                    {Email1 || 'Not specified'}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 600, display: 'block' }}>
                                    Primary Mobile (Mobile 1)
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 700, color: '#0F172A' }}>
                                    {Number1 || 'Not specified'}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 600, display: 'block' }}>
                                    Secondary Email (Email 2)
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#334155' }}>
                                    {Email2 || 'None'}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 600, display: 'block' }}>
                                    Secondary Mobile (Mobile 2)
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#334155' }}>
                                    {Number2 || 'None'}
                                </Typography>
                            </Grid>
                        </Grid>
                        {personalContactErrors.length > 0 && (
                            <Typography variant="caption" sx={{ color: '#B91C1C', fontWeight: 700, display: 'block', mt: 1.5 }}>
                                {personalContactErrors[0].message}
                            </Typography>
                        )}
                    </Box>
                ) : (
                    <>
                        <Grid sx={{ display: 'flex' }} container mt={0} spacing={2}>
                            <Grid item md={6} xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                    <TextField
                                        required
                                        id="parent-field-Email1"
                                        variant="outlined"
                                        className={classes.inpfield}
                                        error={showParentFieldError('Email1')}
                                        FormHelperTextProps={{ style: { color: 'red', height: '15px', marginLeft: '0px', fontSize: '12px' } }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <BadgeOutlinedIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        InputLabelProps={{ style: { fontSize: '14px' } }}
                                        type="text"
                                        label={"Email 1"}
                                        value={Email1 || ''}
                                        name="Email1"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        helperText={parentFieldHelper('Email1')}
                                        sx={{
                                            bgcolor: 'white',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                    <TextField
                                        required
                                        id="parent-field-Number1"
                                        variant="outlined"
                                        className={classes.inpfield}
                                        error={showParentFieldError('Number1')}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <StayPrimaryPortraitOutlinedIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        InputLabelProps={{ style: { fontSize: '14px' } }}
                                        type="text"
                                        label={`Mobile 1 ${NumberInitial1}`}
                                        value={Number1 || ''}
                                        name="Number1"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        FormHelperTextProps={{ style: { color: 'red', height: '15px', marginLeft: '0px', fontSize: '12px' } }}
                                        helperText={parentFieldHelper('Number1')}
                                        sx={{
                                            bgcolor: 'white',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid sx={{ display: 'flex' }} container mt={0} spacing={2}>
                            <Grid item md={6} xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                    <TextField
                                        id="parent-field-Email2"
                                        variant="outlined"
                                        className={classes.inpfield}
                                        error={showParentFieldError('Email2')}
                                        FormHelperTextProps={{ style: { color: 'red', height: '15px', marginLeft: '0px', fontSize: '12px' } }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <BadgeOutlinedIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        InputLabelProps={{ style: { fontSize: '14px' } }}
                                        type="text"
                                        label={"Email 2"}
                                        value={Email2 || ''}
                                        name="Email2"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        helperText={parentFieldHelper('Email2')}
                                        sx={{
                                            bgcolor: 'white',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                    <TextField
                                        id="parent-field-Number2"
                                        variant="outlined"
                                        className={classes.inpfield}
                                        error={showParentFieldError('Number2')}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <StayPrimaryPortraitOutlinedIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        InputLabelProps={{ style: { fontSize: '14px' } }}
                                        type="text"
                                        label={`Mobile 2 ${NumberInitial2}`}
                                        value={Number2 || ''}
                                        name="Number2"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        FormHelperTextProps={{ style: { color: 'red', height: '15px', marginLeft: '0px', fontSize: '12px' } }}
                                        helperText={parentFieldHelper('Number2')}
                                        sx={{
                                            bgcolor: 'white',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </>
                )}

                {personalContactErrors.length > 0 && attemptedStep0Next && (
                    <Box sx={{ mb: 2 }}>
                        {missingInfoAlert(
                            'Fix these contact details before continuing:',
                            personalContactErrors.map((error) => error.message)
                        )}
                    </Box>
                )}

                {/* Residential Address Header */}
                <Grid sx={{ display: 'flex' }} container mt={0} spacing={2}>
                    <Grid item xs={12}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.25,
                            width: '100%',
                            backgroundColor: '#F8FAFC',
                            border: '1px solid #E2E8F0',
                            borderRadius: '12px',
                            padding: '10px 16px',
                            mt: 3,
                            mb: 2,
                        }}>
                            <Box sx={{ width: 4, height: 20, bgcolor: '#059669', borderRadius: 2 }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0F172A', fontSize: { xs: '14.5px', sm: '16px' }, flex: 1 }}>
                                Residential Address
                            </Typography>
                            <Button
                                size="small"
                                startIcon={<ModeEditOutlineTwoToneIcon />}
                                onClick={() => setIsEditingAddress(!isEditingAddress)}
                                sx={{
                                    color: '#059669',
                                    fontWeight: 700,
                                    textTransform: 'none',
                                    bgcolor: 'rgba(5, 150, 105, 0.08)',
                                    borderRadius: '8px',
                                    px: 1.5,
                                    '&:hover': { bgcolor: 'rgba(5, 150, 105, 0.15)' }
                                }}
                            >
                                {isEditingAddress ? "Done" : "Change"}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

                {!isEditingAddress ? (
                    <Box
                        id="parent-field-Address1"
                        sx={{
                            p: 2,
                            borderRadius: '12px',
                            bgcolor: addressContactErrors.length ? '#FEF2F2' : '#F8FAFC',
                            border: addressContactErrors.length ? '1.5px solid #EF4444' : '1px solid #E2E8F0',
                            mb: 2
                        }}
                    >
                        <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 600, display: 'block', mb: 0.5 }}>
                            Current Address
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 700, color: '#0F172A' }}>
                            {Address1 || ''} {Address2 ? `, ${Address2}` : ''} {Address3 ? `, ${Address3}` : ''}
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: '#475569', mt: 0.5 }}>
                            {Town || ''} {State || 'WA'} {PostCode || ''}
                        </Typography>
                        {addressContactErrors.length > 0 && (
                            <Typography variant="caption" sx={{ color: '#B91C1C', fontWeight: 700, display: 'block', mt: 1.5 }}>
                                {addressContactErrors[0].message}
                            </Typography>
                        )}
                    </Box>
                ) : (
                    <>
                        <Grid sx={{ display: 'flex' }} container mt={0} spacing={2}>
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                    <TextField
                                        required
                                        id="parent-field-Address1"
                                        variant="outlined"
                                        multiline
                                        className={classes.Txtareafield}
                                        error={showParentFieldError('Address1')}
                                        FormHelperTextProps={{ style: { color: 'red', height: '15px', marginLeft: '0px', fontSize: '12px' } }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <HomeIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        InputLabelProps={{ style: { fontSize: '14px' } }}
                                        type="text"
                                        label={"Address Line 1"}
                                        value={Address1 || ''}
                                        name="Address1"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        helperText={parentFieldHelper('Address1')}
                                        sx={{
                                            bgcolor: 'white',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid sx={{ display: 'flex' }} container mt={0} spacing={2}>
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                    <TextField
                                        id="parent-field-Address2"
                                        variant="outlined"
                                        multiline
                                        className={classes.Txtareafield}
                                        error={showParentFieldError('Address2')}
                                        FormHelperTextProps={{ style: { color: 'red', height: '15px', marginLeft: '0px', fontSize: '12px' } }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <HomeIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        InputLabelProps={{ style: { fontSize: '14px' } }}
                                        type="text"
                                        label={"Address Line 2"}
                                        value={Address2 || ''}
                                        name="Address2"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        helperText={parentFieldHelper('Address2')}
                                        sx={{
                                            bgcolor: 'white',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid sx={{ display: 'flex' }} container mt={0} spacing={2}>
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                    <TextField
                                        id="parent-field-Address3"
                                        variant="outlined"
                                        multiline
                                        className={classes.Txtareafield}
                                        error={showParentFieldError('Address3')}
                                        FormHelperTextProps={{ style: { color: 'red', height: '15px', marginLeft: '0px', fontSize: '12px' } }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <HomeIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        InputLabelProps={{ style: { fontSize: '14px' } }}
                                        type="text"
                                        label={"Address Line 3"}
                                        value={Address3 || ''}
                                        name="Address3"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        helperText={parentFieldHelper('Address3')}
                                        sx={{
                                            bgcolor: 'white',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid sx={{ display: 'flex' }} container mt={0} spacing={2}>
                            <Grid item md={4} xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
                                    <TextField
                                        required
                                        id="parent-field-Town"
                                        variant="outlined"
                                        className={classes.inpfield}
                                        error={showParentFieldError('Town')}
                                        FormHelperTextProps={{ style: { color: 'red', height: '15px', marginLeft: '0px', fontSize: '12px' } }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <BadgeOutlinedIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        InputLabelProps={{ style: { fontSize: '14px' } }}
                                        type="text"
                                        label={"Town"}
                                        value={Town || ''}
                                        name="Town"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        helperText={parentFieldHelper('Town')}
                                        sx={{
                                            bgcolor: 'white',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <TextField
                                        required
                                        id="parent-field-PostCode"
                                        variant="outlined"
                                        className={classes.inpfield}
                                        error={showParentFieldError('PostCode')}
                                        FormHelperTextProps={{ style: { color: 'red', height: '15px', marginLeft: '0px', fontSize: '12px' } }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SignpostIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        InputLabelProps={{ style: { fontSize: '14px' } }}
                                        type="text"
                                        label={"Post Code"}
                                        value={PostCode || ''}
                                        name="PostCode"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        helperText={parentFieldHelper('PostCode')}
                                        sx={{
                                            bgcolor: 'white',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <InputLabel className={classes.StateOptionLabel} sx={{ mb: 0.5 }}>State</InputLabel>
                                    <Box id="parent-field-State">
                                        <IOSSegmentedControl
                                            options={[{ label: 'WA', value: 'WA' }, { label: 'SA', value: 'SA' }]}
                                            value={State || 'WA'}
                                            onChange={(val) => formik.setFieldValue('State', val)}
                                            error={showParentFieldError('State')}
                                        />
                                    </Box>
                                    {showParentFieldError('State') && (
                                        <Typography variant="caption" sx={{ color: '#D32F2F', mt: 0.5 }}>
                                            {parentFieldHelper('State')}
                                        </Typography>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </>
                )}

                {addressContactErrors.length > 0 && attemptedStep0Next && (
                    <Box sx={{ mb: 2, mt: 1 }}>
                        {missingInfoAlert(
                            'Fix these address details before continuing:',
                            addressContactErrors.map((error) => error.message)
                        )}
                    </Box>
                )}

                {/* Family Medicare Details */}
                <Grid id="family-medicare-section" sx={{ display: 'flex', mt: 3 }} container mb={0}>
                    <Grid item md={12} xs={12}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 1.25,
                            width: '100%',
                            backgroundColor: '#F8FAFC',
                            border: '1px solid #E2E8F0',
                            borderRadius: '12px',
                            padding: '10px 16px',
                            mb: 2,
                        }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#059669', borderRadius: 2 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0F172A', fontSize: { xs: '14.5px', sm: '16px' }, flex: 1 }}>
                                    Family Medicare Card
                                </Typography>
                            </Box>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={ParentNoMedicare}
                                        onChange={(e) => {
                                            setParentNoMedicare(e.target.checked);
                                            SetMedicareImages([]);
                                            if (e.target.checked) {
                                                setParentMedicareNumber('');
                                                setParentMedicareExpiry('');
                                            }
                                        }}
                                        size="small"
                                        sx={{ py: 0 }}
                                    />
                                }
                                label={<Typography variant="body2" sx={{ fontWeight: 600 }}>I don't have one</Typography>}
                                sx={{ m: 0 }}
                            />
                        </Box>
                    </Grid>
                </Grid>

                {!ParentNoMedicare && (
                    <Box sx={{ p: { xs: 2, sm: 3 }, borderRadius: '12px', bgcolor: '#FFFFFF', border: '1px solid #E2E8F0', mb: 3 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                            <TextField
                                required
                                fullWidth
                                variant="outlined"
                                label="10-Digit Medicare Number"
                                sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                placeholder="1234567890"
                                value={ParentMedicareNumber}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, '').substring(0, 10);
                                    if (val !== ParentMedicareNumber) SetMedicareImages([]);
                                    setParentMedicareNumber(val);
                                }}
                                error={!ParentMedicareValid || ParentMedicareNumber === ''}
                                helperText={
                                    ParentMedicareNumber === ''
                                        ? "Medicare number is required, or tick \"I don't have one\""
                                        : (!ParentMedicareValid ? "Must be 10 digits" : "")
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                required
                                fullWidth
                                variant="outlined"
                                label="Expiry Date (MM/YYYY)"
                                sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                placeholder="MM/YYYY"
                                value={ParentMedicareExpiry}
                                onChange={(e) => {
                                    let val = e.target.value.replace(/[^\d/]/g, '');
                                    if (val.length === 2 && !val.includes('/') && e.nativeEvent.inputType !== 'deleteContentBackward') {
                                        val = val + '/';
                                    }
                                    val = val.substring(0, 7);
                                    if (val !== ParentMedicareExpiry) SetMedicareImages([]);
                                    setParentMedicareExpiry(val);
                                }}
                                error={!ParentMedicareExpiryValid || familyMedicareExpired}
                                helperText={
                                    ParentMedicareExpiry === ''
                                        ? 'Expiry date is required'
                                        : (!ParentMedicareExpiryValid
                                            ? 'Enter a valid month and year as MM/YYYY'
                                            : (familyMedicareExpired
                                                ? 'This card has expired. Enter an expiry later than the current month.'
                                                : ''))
                                }
                                FormHelperTextProps={{
                                    sx: familyMedicareExpired && ParentMedicareExpiryValid
                                        ? { color: '#D32F2F' }
                                        : undefined,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
                )}

                {familyUploadRequired && familyMedicareErrors.length === 0 && (
                    <Medicare
                        showMedicareUpload={true}
                        anyTempVisaSelected={false}
                        isMedicareMandatory={true}
                        SetMedicareImages={SetMedicareImages}
                        medicareImages={medicareImages}
                        error={familyUploadError}
                        storedUrls={familyStoredCard}
                        onRemoveStored={(index) => setClearedFamilySlots((current) => {
                            const next = [...current];
                            next[index] = true;
                            return next;
                        })}
                    />
                )}

                {familyMedicareErrors.length > 0 && (
                    <Box sx={{ mb: 3 }}>
                        {missingInfoAlert(
                            'Complete the Family Medicare Card section before continuing:',
                            familyMedicareErrors
                        )}
                    </Box>
                )}

                {/* Students Enroled Overview List */}
                <Box id="student-selection-section" sx={{ mt: 3, mb: 1 }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.25,
                        width: '100%',
                        backgroundColor: '#F8FAFC',
                        border: '1px solid #E2E8F0',
                        borderRadius: '12px',
                        padding: '10px 16px',
                        mb: 2,
                    }}>
                        <Box sx={{ width: 4, height: 20, bgcolor: '#059669', borderRadius: 2 }} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0F172A', fontSize: { xs: '14.5px', sm: '16px' } }}>
                            Students Selected for Re-enrolment
                        </Typography>
                    </Box>

                    <Alert
                        severity="warning"
                        icon={<WarningAmberRoundedIcon fontSize="inherit" />}
                        sx={{
                            mb: 2,
                            borderRadius: '8px',
                            alignItems: 'flex-start',
                            bgcolor: '#fffbeb',
                            border: '1px solid #fcd34d',
                            color: '#92400e',
                            '& .MuiAlert-icon': { color: '#d97706', pt: 0.25 },
                        }}
                    >
                        {isAdelaideCampusFamily(college, childrens)
                            ? 'Please double-check your selection — any child not selected now cannot be added later.'
                            : 'Please double-check your selection — any child not selected now cannot be added later, and you may lose eligibility for sibling discounts.'}
                    </Alert>

                    <Grid container spacing={2}>
                        {childrens?.map((child, index) => {
                            const rec = medicalRecords[index];
                            const isEligible = isEligibleForReenrolment(child);
                            // A child an earlier, paid re-enrolment already covered. Shown rather
                            // than hidden — a family with two children expects to see both, and
                            // dropping one invites a call asking what became of them — but with
                            // nothing to decide, because there is nothing left to decide.
                            const paidCampus = paidCampusForChild(child, paidCampuses);
                            // Another parent code's child, re-enrolled under their own sign-in.
                            const otherParentCode = otherParentCodeChildren
                                .find((c) => String(c.stud_code).trim() === String(childCode(child)).trim())
                                ?.parent_code;
                            const isAlreadyDone = Boolean(paidCampus) || Boolean(otherParentCode) || alreadyReEnrolled
                                .map((code) => String(code).trim())
                                .includes(String(childCode(child)).trim());
                            const isEnrolled = !isAlreadyDone && isRecordEnrolled(rec, child);

                            return (
                                <Grid item xs={12} sm={6} key={index}>
                                    <Box
                                        sx={{
                                            p: 2,
                                            borderRadius: '16px',
                                            bgcolor: isEnrolled ? '#ECFDF5' : '#F8FAFC',
                                            border: isEnrolled ? '1.5px solid #A7F3D0' : '1.5px solid #E2E8F0',
                                            display: 'flex',
                                            flexDirection: { xs: 'column', sm: 'row' },
                                            alignItems: { xs: 'stretch', sm: 'center' },
                                            justifyContent: 'space-between',
                                            gap: 1.5,
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <Avatar sx={{ bgcolor: isEnrolled ? '#059669' : '#94A3B8', fontWeight: 700, width: 42, height: 42 }}>
                                                {childGivenName(child) ? childGivenName(child)[0] : 'S'}
                                            </Avatar>
                                            <Box>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: isEnrolled ? '#065F46' : '#475569' }}>
                                                    {childFullName(child)}
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: isEnrolled ? '#047857' : '#64748B', display: 'block' }}>
                                                    Year: {childYearLevel(child)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={{ minWidth: 160 }}>
                                            {isAlreadyDone ? (
                                                <Chip
                                                    label={paidCampus
                                                        ? `Paid — ${paidCampus.college}${paidCampus.t_date ? `, ${paidCampus.t_date}` : ''}`
                                                        : otherParentCode
                                                            ? `Re-enrolled under Parent Code ${otherParentCode}`
                                                            : `Already re-enrolled for ${reenrolmentYear()}`}
                                                    size="small"
                                                    sx={{ bgcolor: '#ECFDF5', color: '#065F46', fontWeight: 700, fontSize: '11px' }}
                                                />
                                            ) : isEligible ? (
                                                <IOSSegmentedControl
                                                    options={[
                                                        { label: 'Enrolling', value: 'Enrolled' },
                                                        { label: 'Leaving AIC', value: 'Not Enrolled' }
                                                    ]}
                                                    value={isEnrolled ? 'Enrolled' : 'Not Enrolled'}
                                                    onChange={(val) => handleChildEnrollToggle(index, val)}
                                                />
                                            ) : (
                                                <Chip
                                                    label="Not eligible for re-enrolment"
                                                    size="small"
                                                    sx={{ bgcolor: '#F1F5F9', color: '#475569', fontWeight: 700, fontSize: '11px' }}
                                                />
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>
                            );
                        })}
                    </Grid>

                    {noStudentSelected && (
                        <Box sx={{ mt: 2 }}>
                            {missingInfoAlert(
                                'Select at least one student to re-enrol:',
                                ['Mark at least one eligible student as Enrolling to continue.']
                            )}
                        </Box>
                    )}

                    {totalMedicalScreens > 0 && totalMedicalScreens < (childrens?.length || 0) && (
                        <Typography variant="body2" sx={{ mt: 2, color: '#475569' }}>
                            {`You will complete medical details for ${totalMedicalScreens} of ${childrens.length} students. Students marked "Leaving AIC" are skipped.`}
                        </Typography>
                    )}
                </Box>


            </Box>
            </Box>
            )}

            {/* Screen 2..N: Dedicated Student Medical Screen (1 student at a time) */}
            {activeSubStep > 0 && currentStudentIndex >= 0 && (() => {
                const totalStudents = totalMedicalScreens;
                const currentChild = childrens?.[currentStudentIndex];

                return (
                    <Box sx={{ width: '100%', mt: 2 }}>
                        {/* Top Back & Header Bar */}
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                            <Button
                                startIcon={<ArrowBackIcon />}
                                onClick={() => goToStudentScreen(Math.max(0, activeSubStep - 1))}
                                sx={{ color: '#059669', fontWeight: 700, textTransform: 'none' }}
                            >
                                {activeSubStep === 1 ? "Back to Parent Details" : "Previous Student"}
                            </Button>
                            <Chip
                                label={`Medical Screen ${activeSubStep} of ${totalStudents}`}
                                size="small"
                                sx={{ bgcolor: '#ECFDF5', color: '#065F46', fontWeight: 700, fontSize: '12px' }}
                            />
                        </Box>

                        {/* Dedicated Focus Banner for Active Student */}
                        <Box
                            sx={{
                                p: 2.5,
                                mb: 3,
                                borderRadius: '16px',
                                background: 'linear-gradient(135deg, #ECFDF5 0%, #F0FDF4 100%)',
                                border: '1px solid #A7F3D0',
                                boxShadow: '0 4px 20px rgba(5, 150, 105, 0.06)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                    <Avatar sx={{ bgcolor: '#059669', color: '#FFF', fontWeight: 800, width: 48, height: 48, fontSize: '1.2rem' }}>
                                        {childGivenName(currentChild) ? childGivenName(currentChild)[0] : activeSubStep}
                                    </Avatar>
                                    <Box>
                                        <Typography variant="h6" sx={{ fontWeight: 800, color: '#065F46', fontSize: '1.2rem' }}>
                                            Medical Record: {childFullName(currentChild)}
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: '#047857', fontWeight: 600 }}>
                                            Student ID: {childCode(currentChild)} • Year Level: {childYearLevel(currentChild)}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box sx={{ minWidth: 140, textAlign: 'right' }}>
                                    <Typography variant="caption" sx={{ color: '#047857', fontWeight: 700 }}>
                                        Student {activeSubStep} of {totalStudents}
                                    </Typography>
                                    <LinearProgress
                                        variant="determinate"
                                        value={(activeSubStep / totalStudents) * 100}
                                        sx={{
                                            height: 6,
                                            borderRadius: 3,
                                            bgcolor: '#A7F3D0',
                                            '& .MuiLinearProgress-bar': { bgcolor: '#059669', borderRadius: 3 },
                                            mt: 0.5
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Box>

                        {/* Render Medical Form ONLY for Current Student */}
                        <StudentMedicalForm
                            items={StudentMedicalDetails}
                            singleStudentIndex={currentStudentIndex}
                            setUpdateMedicalRecords={setUpdateMedicalRecordsFunc}
                            SetValidMedicare={SetValidMedicare}
                            SetValidMedicareExpiry={SetValidMedicareExpiry}
                            SetValidAmbulanceCover={SetValidAmbulanceCover}
                            SetValidImmunisationStatus={SetValidImmunisationStatus}
                            SetValidAllergy={SetValidAllergy}
                            SetValidPHI={SetValidPHI}
                            parentMedicareNumber={ParentMedicareNumber}
                            parentMedicareExpiry={ParentMedicareExpiry}
                            parentNoMedicare={ParentNoMedicare}
                            studentMedicareImages={studentMedicareImages}
                            setStudentMedicareImages={setStudentMedicareImages}
                            studentStoredCards={studentStoredCards}
                            onRemoveStudentStoredCard={(studentCode, index) => setClearedStudentSlots((current) => {
                                const cleared = [...(current[studentCode] || [])];
                                cleared[index] = true;
                                return { ...current, [studentCode]: cleared };
                            })}
                        />

                        {currentStudentErrors.filter((error) => error.field !== 'medicare_images').length > 0 && (
                            <Box sx={{ mt: 3 }}>
                                {missingInfoAlert(
                                    `Complete these details for ${childGivenName(currentChild) || 'this student'} before continuing:`,
                                    currentStudentErrors
                                        .filter((error) => error.field !== 'medicare_images')
                                        .map((error) => error.message)
                                )}
                            </Box>
                        )}

                        {currentStudentErrors.length === 0 && incompleteStudents.length > 0 && (
                            <Box sx={{ mt: 3 }}>
                                <Alert
                                    severity="warning"
                                    icon={<WarningAmberRoundedIcon fontSize="inherit" />}
                                    sx={{
                                        borderRadius: '12px',
                                        alignItems: 'flex-start',
                                        bgcolor: '#FFFBEB',
                                        border: '1px solid #FCD34D',
                                        color: '#92400E',
                                        '& .MuiAlert-icon': { color: '#D97706', pt: 0.25 },
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 700, fontSize: '13.5px', mb: 0.5 }}>
                                        Some other students still need attention
                                    </Typography>
                                    {incompleteStudents.map((issue) => (
                                        <Button
                                            key={issue.studentIndex}
                                            size="small"
                                            onClick={() => goToStudentScreen(issue.screen)}
                                            sx={{ textTransform: 'none', fontWeight: 700, color: '#B45309', px: 0.5 }}
                                        >
                                            {`Fix ${issue.name} (${issue.errors.length} missing)`}
                                        </Button>
                                    ))}
                                </Alert>
                            </Box>
                        )}

                        {/* Space for Universal Sticky Action Bar */}
                        <Box sx={{ pb: 12 }} />
                    </Box>
                );
            })()}

            {/* Universal Sticky Glassmorphism Action Bar */}
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    px: { xs: 2, md: 4 },
                    py: 1.5,
                    bgcolor: 'rgba(255, 255, 255, 0.94)',
                    backdropFilter: 'blur(16px)',
                    borderTop: '1px solid rgba(226, 232, 240, 0.9)',
                    boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.08)',
                    zIndex: 1100,
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: { xs: 1.5, sm: 2 }
                }}
            >
                {/* Left side: Previous / Step Indicator */}
                <Box sx={{ display: 'flex', alignItems: 'center', width: { xs: '100%', sm: 'auto' }, justifyContent: { xs: 'space-between', sm: 'flex-start' } }}>
                    {activeSubStep > 0 ? (
                        <Button
                            variant="outlined"
                            startIcon={<ArrowBackIcon />}
                            onClick={() => goToStudentScreen(Math.max(0, activeSubStep - 1))}
                            sx={{ borderRadius: '12px', textTransform: 'none', fontWeight: 700, borderColor: '#CBD5E1', color: '#475569', minWidth: { xs: '100%', sm: 'auto' } }}
                        >
                            {activeSubStep === 1 ? "Back" : "Previous Student"}
                        </Button>
                    ) : (
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 600, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                Step 2 of 7
                            </Typography>
                            <Typography variant="subtitle2" sx={{ color: '#0F172A', fontWeight: 700, fontSize: '13px' }}>
                                Parent & Selection
                            </Typography>
                        </Box>
                    )}
                </Box>

                {/* Right side: Checkbox + Next Button */}
                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: { xs: 'column', sm: 'row' }, width: { xs: '100%', sm: 'auto' }, gap: { xs: 1.5, sm: 2 } }}>
                    {activeSubStep > 0 && activeSubStep >= totalMedicalScreens && (
                        <FormControlLabel
                            control={
                                <Checkbox name="accepted" checked={accepted} onChange={formik.handleChange} color="primary"
                                    sx={{
                                        padding: '0px 8px 0px 8px',
                                        '&.Mui-checked': { color: green[900] }
                                    }}
                                />
                            }
                            label={
                                <Typography sx={{ fontSize: { xs: '13px', sm: '14px' }, fontWeight: 600, color: '#0F172A' }}>
                                    I have reviewed the information
                                </Typography>
                            }
                            sx={{ m: 0, alignSelf: { xs: 'flex-start', sm: 'center' } }}
                        />
                    )}

                    {activeSubStep === 0 ? (
                        <Button
                            variant="contained"
                            size="large"
                            endIcon={<NavigateNextIcon />}
                            onClick={handleParentStepNext}
                            sx={{
                                bgcolor: '#059669', color: '#FFFFFF', fontWeight: 700, px: 3, py: 1.25, borderRadius: '12px', textTransform: 'none', fontSize: '15px', minHeight: '48px', boxShadow: '0 4px 14px rgba(5, 150, 105, 0.35)', '&:hover': { bgcolor: '#047857' },
                                '&.Mui-disabled': { bgcolor: '#E2E8F0', color: '#94A3B8' }, width: { xs: '100%', sm: 'auto' }
                            }}
                        >
                            Next
                        </Button>
                    ) : activeSubStep < totalMedicalScreens ? (
                        <Button
                            variant="contained"
                            size="large"
                            endIcon={<NavigateNextIcon />}
                            onClick={handleStudentStepNext}
                            sx={{
                                bgcolor: '#059669', color: '#FFFFFF', fontWeight: 700, px: 3, py: 1.25, borderRadius: '12px', textTransform: 'none', fontSize: '15px', minHeight: '48px', boxShadow: '0 4px 14px rgba(5, 150, 105, 0.35)', '&:hover': { bgcolor: '#047857' },
                                '&.Mui-disabled': { bgcolor: '#E2E8F0', color: '#94A3B8' }, width: { xs: '100%', sm: 'auto' }
                            }}
                        >
                            Next Student ({childGivenName(childrens?.[enrolledStudentIndexes[activeSubStep]])})
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            size="large"
                            endIcon={isLoading ? null : <NavigateNextIcon />}
                            disabled={!accepted || isLoading}
                            onClick={handleSaveAndNext}
                            sx={{
                                bgcolor: '#059669', color: '#FFFFFF', fontWeight: 700, px: 3, py: 1.25, borderRadius: '12px', textTransform: 'none', fontSize: '15px', minHeight: '48px', boxShadow: '0 4px 14px rgba(5, 150, 105, 0.35)', '&:hover': { bgcolor: '#047857' },
                                '&.Mui-disabled': { bgcolor: '#E2E8F0', color: '#94A3B8' }, width: { xs: '100%', sm: 'auto' }
                            }}
                        >
                            {isLoading ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <CircularProgress size={18} sx={{ color: '#94A3B8' }} />
                                    Saving...
                                </Box>
                            ) : (
                                'Save & Next'
                            )}
                        </Button>
                    )}
                </Box>
            </Box>
        </>
    );




    return (
        <>
            <LoadingBackdrop
                open={LoadingModalOpen || isParentHistoryLoading || isLoading}
                icon={<CircularProgress sx={{ color: '#fff' }} />}
                message={isLoading ? (savingStatus || 'Saving your details. Please wait...') : ''}
            />
            <MainTemplate college={`${college}`} content={content} SessionID={SessionID} />
        </>
    )

}

export default Updatedetails